import frontMain from "./img-front_main.jpg";
import logoWhite from "./logo-white.png";
import logoColor from "./logo-color.png";
import background from "./loginimage.jpg";
import frendeInsuranceImage from "./FrendeInsuranceImage.jpg";
import horisontalLogo from "./Brage_logo_liggende.png";

import factoring from "./Factoring.png";

export const menuBannerWhite = [logoWhite];
export const headerLogo = [logoColor];
export const footerLogo = [logoWhite];
export const form_web_logo = [horisontalLogo];

export const mainlogo = [logoColor];
export const dashboard = [frontMain];

export const loginBackground = [background];
export const loginLogo = [logoColor];
export const loginInternalBackground = [background];

export const FrendeInsuranceImage = [frendeInsuranceImage];

export const Factoring = [factoring];

export { VildePhone } from "../../brage_external/images";
